import { ENCOUNTER_READ_ONLY_REASON } from "@/lib/encounterApi";

export default function EncounterReadOnlyHint({ locked, children, className = "inline-flex" }) {
  if (!locked) return children;
  return (
    <span title={ENCOUNTER_READ_ONLY_REASON} className={`${className} cursor-not-allowed`}>
      <span className="pointer-events-none">{children}</span>
    </span>
  );
}
